<template>
  <div class="table-action-wrapper">
    <div class="date-range-group d-flex align-items-center">
      <DatePicker :value="query.date.value" :preset-dates="presetDates" range multi-calendars placeholder="Date Range" @change="changeDate" />
      <Select :options="dateByOptions" placeholder="By Raw" data-title="By" class="has-tip date-picker-left" :value="query.date_by.value" @changeValue="changeDateBy"></Select>
    </div>
    <Select :options="statusOptions" placeholder="Status" data-title="Status" class="has-tip" :value="query?.status?.value" @changeValue="changeStatus"></Select>
    <Select :options="createdElapsedOptions" placeholder="Created At Offset" data-title="Created At Offset" class="has-tip" :value="query.created_elapsed.value" @changeValue="changeCreatedElapsed"></Select>
    <Select :options="colorBatchOptions" placeholder="Color Batch" data-title="Color Batch" class="has-tip" :value="query.color_batch.value" @changeValue="changeColorBatch"></Select>
    <Select :options="printMethodOptions" placeholder="Print Method" data-title="Print Method" class="has-tip" :value="query.print_method.value" @changeValue="changePrintMethod"></Select>
    <Select class="m-1 has-tip" source="user/search" type="auto" field="manufacture.user_edit" placeholder="Manufactor" data-title="Manufactor" v-model="query.user_id"></Select>
    <Select :options="priorityOptions" placeholder="Priority" data-title="Priority" class="has-tip" :value="query.priority.value" @changeValue="changePriority"></Select>
  </div>
</template>
<script>
import DatePicker from '@/components/DatePicker.vue'
import moment from 'moment'
export default {
  components: {
    DatePicker
  },
  data() {
    return {
      query: {
        date: {
          value: [],
          valueLabel: '',
          fieldLabel: 'Date Range',
          group: 'date',
          format: '{{ date_by.valueLabel }}: {{ date.valueLabel }}'
        },
        date_by: {
          value: null,
          defaultValue: 'date_created',
          valueLabel: '',
          defaultValueLabel: 'Date Created',
          fieldLabel: 'By',
          group: 'date'
        },
        status: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Status'
        },
        created_elapsed: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Older'
        },
        color_batch: {
          value: '',
          valueLabel: '',
          fieldLabel: 'Color Batch'
        },
        print_method: {
          value: '',
          valueLabel: '',
          fieldLabel: 'Print Method'
        },
        priority: {
          value: null,
          valueLabel: '',
          fieldLabel: 'Priority'
        }
      },
      presetDates: ['Today', 'Yesterday', 'This Week', 'Last Week', '7 Days Ago', 'This Month', 'Last Month', '30 Days Ago', '3 Months Ago', '90 Days Ago', 'This Year']
    }
  },
  created() {
    this.query = Object.assign(this.query, this.config?.query)
  },
  computed: {
    extraAttributes() {
      return this.config?.extraAttributes || {}
    },
    dateByOptions() {
      return Object.values(this.extraAttributes?.date_by || [])
    },
    statusOptions() {
      return Object.values(this.extraAttributes?.status || [])
    },
    createdElapsedOptions() {
      return Object.values(this.extraAttributes?.created_elapsed || [])
    },
    priorityOptions() {
      return Object.values(this.extraAttributes?.priority || [])
    },
    colorBatchOptions() {
      return Object.values(this.extraAttributes?.color_batches || [])
    },
    printMethodOptions() {
      return Object.values(this.extraAttributes?.print_methods || [])
    }
  },
  methods: {
    changeDate(e) {
      if (e === null) {
        this.query.date = Object.assign(this.query.date, {
          value: null,
          valueLabel: ''
        })
      } else if (_.isArray(e)) {
        this.query.date = Object.assign(this.query.date, {
          value: e.map((item) => moment(item).format('YYYY-MM-DD')),
          valueLabel: e.map((item) => moment(item).format('YYYY/MM/DD')).join(' - ')
        })
      } else {
        return
      }
      this.$emit('change-filters', this.query)
    },
    changeDateBy(value, e) {
      this.query.date_by = Object.assign(this.query.date_by, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeStatus(value, e) {
      this.query.status = Object.assign(this.query.status, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeCreatedElapsed(value, e) {
      this.query.created_elapsed = Object.assign(this.query.created_elapsed, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changePriority(value, e) {
      this.query.priority = Object.assign(this.query.priority, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changeColorBatch(value, e) {
      this.query.color_batch = Object.assign(this.query.color_batch, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    },
    changePrintMethod(value, e) {
      this.query.print_method = Object.assign(this.query.print_method, {
        value: e.selected.id,
        valueLabel: e.selected.text
      })
      this.$emit('change-filters', this.query)
    }
  },
  props: {
    config: Object
  }
}
</script>
